import { OrderBookType, OrderType } from '../../config/constants';
import { TradePair } from '../chart/chartTypes';

export type TransactionLog = {
    tradePair: TradePair;
    date: EpochTimeStamp;
    fees?: string;
    volume: string;
    status: OrderType['status'];
    leverage: string;
    isShort: boolean;
    orderType: OrderBookType;
    isMarketOrder: boolean;
    margin?: string;
    newLeverage?: string;
    newMargin?: string;
    newVolume?: string;
    estimatedPnl?: string;
    txHash?: string;
    deadline?: EpochTimeStamp;
    sigHash: string;
    orderId: string;
};

enum TransactionStatus {
    SUBMITTED = 'Submitted',
    FILLED = 'Filled',
    FAILED = 'Failed',
    CANCELLED = 'Cancelled',
    EXPIRED = 'Expired',
    LIQUIDATED = 'Liquidated',
}

export const TransactionStatusMapper: Record<OrderType['status'], TransactionStatus> = {
    pending: TransactionStatus.SUBMITTED,
    requested: TransactionStatus.SUBMITTED,
    executed: TransactionStatus.FILLED,
    error: TransactionStatus.FAILED,
    cancelled: TransactionStatus.CANCELLED,
    expired: TransactionStatus.EXPIRED,
    liquidated: TransactionStatus.FILLED,
};

export type TransactionActions =
    | {
          type: 'ADD_PENDING_TRANSACTION';
          payload: TransactionLog;
      }
    | {
          type: 'REMOVE_PENDING_TRANSACTION';
          payload: string;
          callback?: () => void;
      };

export type TransactionStateType = {
    pendingTransactions: TransactionLog[];
};

export type TransactionFunctions = {
    addPendingTransaction: (pendingTransaction: TransactionLog) => void;
    removePendingTransaction: (sigHash: string) => void;
};

export type TransactionTypes = TransactionStateType & TransactionFunctions;
